import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";
import {
  GroupChatMember,
  MemberOwnershipPayload,
  UpdateMemberPayload,
} from "../types/member";
import {
  DeleteMemberPayload,
  GetMembersByChatIdPayload,
  SearchMembersPayload,
  MemberFromPrefixSearch,
  Member,
} from "../types/member";

export const searchMembers = async ({
  searchTerm,
  member, // pass chatId - gets members INSIDE that chat
  not_member, // pass chatId - gets members OUTSIDE that chat
  offset,
  count,
}: SearchMembersPayload): Promise<MemberFromPrefixSearch[]> => {
  const response = await requestApi({
    url: ApiEndpoints.PREFIX_SEARCH,
    method: "POST",
    params: {
      member,
      not_member,
      offset,
      count,
    },
    data: [searchTerm], // why is this an array?
  });
  return response.data;
};

export const getMembers = async ({
  chat_id,
  skip,
  take,
}: GetMembersByChatIdPayload): Promise<Member[]> => {
  const response = await requestApi(
    {
      url: ApiEndpoints.MEMBERS,
      method: "GET",
      params: {
        chat_id,
        skip,
        take,
      },
    },
    { retry429: true },
  );
  return response.data;
};

export const deleteMember = async ({
  chat_id,
  username,
}: DeleteMemberPayload): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.MEMBERS,
    method: "DELETE",
    params: {
      chat_id,
      username,
    },
  });
};

// add members
export const addMembers = async (members: GroupChatMember[]): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.MEMBERS,
    method: "POST",
    data: members,
  });
};

export type BatchMembersResponse = {
  inserted: number;
  errors: string[];
};

// add members in bulk (dev-only batch path, skips per-member validation/events)
export const addMembersBatch = async (
  members: GroupChatMember[],
): Promise<BatchMembersResponse> => {
  const response = await requestApi({
    url: ApiEndpoints.MEMBERS_BATCH,
    method: "POST",
    data: members,
  });
  return response.data;
};

export const getMember = async (
  username: string,
  chat_id: string,
): Promise<Member> => {
  const response = await requestApi(
    {
      url: `${ApiEndpoints.MEMBERS}/${username}`,
      method: "GET",
      params: {
        chat_id,
      },
    },
    { retry429: true },
  );
  return response.data;
};

export const patchMember = async (
  member: UpdateMemberPayload,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.MEMBERS,
    method: "PATCH",
    data: member,
  });
};

export const patchMemberOwnership = async (
  member: MemberOwnershipPayload,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.TRANSFER_OWNERSHIP,
    method: "PATCH",
    data: member,
  });
};
